import { render, staticRenderFns } from "./gooru-search-card.vue?vue&type=template&id=6978e9d2&"
import script from "./gooru-search-card.ts?vue&type=script&lang=ts&"
export * from "./gooru-search-card.ts?vue&type=script&lang=ts&"
import style0 from "./gooru-search-card.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports